import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { PollInTeam, PollListItem, PollOccurrence } from "app/frontend/lib/polls/user-polls/user-polls.type";
import { UserTeam } from "@teammood/shared/util/user";
import { UserPollOccurenceComponent } from "../user-poll-occurrence/user-poll-occurrence.component";


@Component({
    selector: "user-poll-occurrence-list",
    templateUrl: "./user-poll-occurrence-list.component.html",
    styleUrls: ["./../user-polls.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatTooltipModule,
        TranslateModule,
        UserPollOccurenceComponent
    ],
})
export class UserPollOccurenceListComponent {

    protected showAll: boolean = false;

    @Input() occurrence: PollOccurrence
    @Input() isSelected: boolean;
    @Input() poll: PollListItem;
    @Input() teams: UserTeam[];
    
    @Output() onDeletePollOccurrence = new EventEmitter<PollOccurrence>();
    
    constructor(
    ){}


    protected onDelete(poll: PollOccurrence){
        this.onDeletePollOccurrence.emit(poll);
    }



}